import moment from 'moment';

const diffDays = (a, b) => {
  return moment(b)
    .startOf('day')
    .diff(moment(a).startOf('day'), 'days');
};

export default diffDays;
